// removed by extract-text-webpack-plugin
module.exports = {"block":"WZmAHP4KISUmOCxT84D9J","header":"_3xL9XkHahPjitv8nyj4EIq","content":"_2aBGNFWbQfvmkMFqV8N89m","dropdown-block":"_15RrXUdvlHqiouqxIpmwTm","list":"_1Dz7Oe6Mot_w8UdTYr06sv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VacanciesFilter/VacanciesFilter.module.scss
// module id = 813
// module chunks = 0